<template>
  <div class="weui_cell weui_cell_switch">
    <div class="weui_cell_hd weui_cell_primary">
      <label class="weui_label" :style="labelStyle" v-html="title"></label>
      <inline-desc v-if="inlineDesc">{{inlineDesc}}</inline-desc>
    </div>
    <div class="weui_cell_ft">
      <!-- <input class="weui_switch" type="checkbox" :disabled="disabled" :checked="value" @change="updateValue($event.target.checked)"/> -->
      <input class="weui_switch" type="checkbox" :disabled="disabled" v-model="currentValue"/>
    </div>
  </div>
</template>

<script>
import InlineDesc from '../inline-desc'

export default {
  components: {
    InlineDesc
  },
  computed: {
    labelStyle () {
      let isHTML = /<\/?[^>]*>/.test(this.title)
      let width = Math.min(isHTML ? 5 : (this.title.length + 1), 14) + 'em'
      return {
        width
      }
    }
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: Boolean,
      default: false
    },
    inlineDesc: String
  },
  // methods: {
  //   updateValue (value) {
  //     this.$emit('input', value)
  //     this.$emit('on-change', value)
  //   }
  // },
  watch: {
    currentValue (val) {
      this.$emit('input', val)
      this.$emit('on-change', val)
    },
    value (val) {
      this.currentValue = val
    }
  }
}
</script>

<style lang="less">
@import '../../styles/cui/widget/cui_cell/cui_form/cui_form_common';
@import '../../styles/cui/widget/cui_cell/cui_switch';

.weui_cell_switch .weui_cell_ft {
  font-size: 0;
}
</style>



// WEBPACK FOOTER //
// x-switch.vue?cef0b938